module.exports = __webpack_public_path__ + "img/guangHuaBei.757bac2.png";